
/* eslint-disable no-magic-numbers */

export const userAgent: string = window.navigator.userAgent;

/* browser */
const [browserName, browserVersion]: [string, string] = (() => {
  let tem: RegExpMatchArray | null;
  let M: RegExpMatchArray | string[] = userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(userAgent);
    return ['IE', (tem?.[1] || '')];
  }
  if (M[1] === 'Chrome') {
    tem = userAgent.match(/\bOPR|Edge\/(\d+)/);
    if (tem != null) {
      return ['Opera', tem[1]];
    }
  }
  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
  if ((tem = userAgent.match(/version\/(\d+)/i)) != null) {
    M.splice(1, 1, tem[1]);
  }
  return [M[0], M[1]];
})();

export const browser: { name: string, version: number } = {
  name: browserName,
  version: parseInt(browserVersion, 10) || 0,
}

export const isIE: boolean = browserName === 'IE' || browserName === 'MSIE';
export const isChrome: boolean = browserName === 'Chrome';
export const isSafari: boolean = browserName === 'Safari';
export const isFirefox: boolean = browserName === 'Firefox';
export const isSogou: boolean = /Sogou/.test(userAgent);
export const isUC: boolean = /UCBrowser/.test(userAgent);
export const ucVersion: number = (isUC && parseInt(userAgent.split('UCBrowser/').pop()?.split('.').shift() || '0', 10)) || 0;
export const isOppo: boolean = /OppoBrowser/.test(userAgent);
export const oppoVersion: number = (isOppo && parseInt(userAgent.split('OppoBrowser/').pop()?.split('.').join('') || '0', 10)) || 0;
export const isHeyTapBrowser = /HeyTapBrowser/.test(userAgent);
const isEdgeHTML: boolean =
  /Edge\/\d+/.test(userAgent) && !/Edg\//.test(userAgent);

const isOperaMini: boolean = /Opera Mini/i.test(userAgent);
const isQQBrowser: boolean = /QQBrowser/i.test(userAgent);
const isBaiduBrowser: boolean = /Baidu/i.test(userAgent);
const isAmazonSilk: boolean = /Silk/i.test(userAgent);
const isKaiOS: boolean = /KaiOS/i.test(userAgent);

/* platform */
export const isTablet: boolean = /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent.toLowerCase());
export const isMobile: boolean = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
export const isMac: boolean = /Macintosh/.test(userAgent);

export const isAndroid: boolean = /(android)/i.test(userAgent);
export const isIOS: boolean = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
export const iosVersion: number | false = isIOS && (() => {
  const VERSION_LENGTH_IN_USER_AGENT: number = 3;
  const VERSION_PREFIX: string = 'OS ';
  const start: number = userAgent.indexOf(VERSION_PREFIX);
  if (start > -1) {
    return parseFloat(userAgent.substr(start + VERSION_PREFIX.length, VERSION_LENGTH_IN_USER_AGENT).replace('_', '.')) || 0;
  }
  return 0;
})();

const isAndroidBrowser: boolean =
  isAndroid &&
  !isChrome &&
  !/SamsungBrowser/i.test(userAgent) &&
  !/UCBrowser/i.test(userAgent);
const isAndroidWebView: boolean =
  isAndroid && /Version\/\d+\.\d+/.test(userAgent) && /Chrome\/\d+/.test(userAgent);

export function isSearchBot() {
  const botKeywords = [
      'SogouMSE', // Характерно для указанных User-Agent
      'COVC',     // Присутствует в строках User-Agent ботов
      'Googlebot',
      'Baiduspider',
      'MQQBrowser/15.2' // Версия, связанная с ботами
  ];
  return botKeywords.some(keyword => userAgent.includes(keyword));
}

export function isFileTransferBlockedByBrowser() {
  return isOppo && oppoVersion && oppoVersion < 202
}

export function isBrowserSuppotSymbol() {
  return !(isSafari && browser.version < 9)
}

export const isIFrame = () => !(window.top === window);

export const historyLength = () => (window.history ? window.history.length : 0)

export const isLegacyBundle: boolean = (() => {
  try {
    if (typeof Promise.any !== 'function') return true /* Chrome 85+, Firefox 79+, Safari 14+ */
    if (!String.prototype.replaceAll) return true      /* Chrome 85+, Firefox 77+             */
    new Function('let a = 1; a &&= 2;')                /* Chrome 85,  Firefox 79,  Safari 14  */
    if (typeof BigInt === 'undefined') return true     /* Chrome 67+, Firefox 68+, Safari 14+ */
    return false;
  } catch (e) {
    return true;
  }
})()

export function isWindows11(): boolean | undefined {
  try {
    const platform = window.navigator.platform || '';
    if (platform.indexOf('Win') === 0) {
      const canvas = document.createElement('canvas');
      const drawContext = canvas.getContext('2d');
      if (drawContext) {
        const fontPrefix = '72px ';
        const measureWidth = (fontStyle: string): number => {
          drawContext.font = fontStyle;
          return drawContext.measureText('i').width;
        };

        const fallbackTextWidth = measureWidth(fontPrefix + 'monospace');
        const targetTextWidth = measureWidth(fontPrefix + "'Segoe UI Variable Text',monospace");
        return fallbackTextWidth !== targetTextWidth;
      }
    }
  } catch (error) {}
}
